const heroLocalization = {
	welcomeMessage: "Software Engineer in Beirut",
	name: "Mohammad Chreif",
	arabicName: "محمد شريف",
	description:
		"I design and build fast, elegant web products end to end, from the database and the cloud to the last pixel of the interface, in English and in Arabic.",
};

export default heroLocalization;
